import { render, staticRenderFns } from "./similarPicture.vue?vue&type=template&id=697d7b82&scoped=true"
import script from "./similarPicture.vue?vue&type=script&lang=js"
export * from "./similarPicture.vue?vue&type=script&lang=js"
import style0 from "./similarPicture.vue?vue&type=style&index=0&id=697d7b82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697d7b82",
  null
  
)

export default component.exports